
import React from 'react';
import { Button } from "@/components/ui/button";
import { Share2, Save, Printer } from "lucide-react";

interface ActionButtonsProps {
  onSave: () => void;
  onShare: () => void;
  onPrint: () => void;
  onClose: () => void;
  disabled?: boolean;
}

export function ActionButtons({ onSave, onShare, onPrint, onClose, disabled = false }: ActionButtonsProps) {
  return (
    <div className="flex justify-between w-full">
      <div className="flex gap-2">
        <Button variant="outline" size="sm" onClick={onSave} disabled={disabled}>
          <Save className="h-4 w-4 mr-1" />
          Salva
        </Button>
        <Button variant="outline" size="sm" onClick={onShare} disabled={disabled}>
          <Share2 className="h-4 w-4 mr-1" />
          Condividi
        </Button>
        <Button variant="outline" size="sm" onClick={onPrint} disabled={disabled}>
          <Printer className="h-4 w-4 mr-1" />
          Stampa
        </Button>
      </div>
      <Button variant="ghost" size="sm" onClick={onClose}>
        Chiudi
      </Button>
    </div>
  );
}
